import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const FileUploadPreviewContainer = styled.div`
  .file-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    background-color: ${COLORS.cirrus_black1};
    width: 361px;
    padding: 12px;
    border: 1px solid ${COLORS.cirrus_black4};
    border-radius: 8px;
    ${responsive.MOBILE`
        margin-top: 0;
        margin: 16px 0 16px 0;
        width: auto;
        max-width: 100%;
    `}
  }

  .file-info-content {
    display: flex;
    flex-direction: column;
  }

  .file-preview-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .file-text-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .file-preview-button {
    padding: 0;
    height: auto;
    text-align: start;
  }

  .excel-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .excel-image img {
    width: 32px;
    height: 32px;
  }

  .file-name {
    width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: ${COLORS.cirrus_black1};
    text-transform: none;
  }

  .label {
    margin-left: 0;
  }

  .file-info-content-icons {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 16px;
    ${responsive.MOBILE`
      gap: 8px;
    `}
  }

  .close-image {
    color: ${COLORS.primary_light_blue};
  }
`;
